import { render, staticRenderFns } from "./Convenciones.vue?vue&type=template&id=2016fc25"
import script from "./Convenciones.vue?vue&type=script&lang=js"
export * from "./Convenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports